import * as THREE from 'three';

import Assets from "./assets";
import Card from "./card";

// import { angleToVector } from "@trinketmage/sword";

const TAU = (Math.PI * 2.);
const SLICE = TAU / 8;

import { angleToVector } from "./utils";

const SPACE = 2;
const SCALAR = 3;

export default class Circles {
    cards = [];
    flashCards = [];
    dummyPosition = new THREE.Vector3();
    FRUSTUM_WIDTH = 7
    lastIndex = 4
    elements = []
    
    constructor({ scene, attributes }) {
        this.scene = scene;
        this.rail = new THREE.Group();
        this.group = new THREE.Group();
        this.links = new THREE.Group();
        this.group.add(this.links)
        this.rail.add(this.group)
        this.scene.add(this.rail);
    }

    initialize() {
        this.lastIndex = this.elements.length + 3

        const { dummyPosition } = this;
        const { links, group, cards } = this
        for(let index = 0; index < 4 + this.elements.length + 1; index++) {
            const iAmSpecial = index >= 4 && index < 4 + this.elements.length;
            const card = new Card({ scene: iAmSpecial ? links : group });
            if (index < 4) {
                card.material.uniforms.map.value = Assets.dnaAssets[index]
                card.material.uniforms.ratio.value = Assets.dnaAssets[index].width / Assets.dnaAssets[index].height
            } else if (iAmSpecial) {
                const imgElement = this.elements[index - 4].querySelector("figure img")

                const texture = new THREE.Texture(imgElement);
                texture.minFilter = THREE.LinearFilter;
                texture.needsUpdate = true;
                card.clone.userData.link = this.elements[index - 4].getAttribute("href")
                card.material.uniforms.map.value = texture;
                card.material.uniforms.reversed.value = 1.0;
                card.material.uniforms.ratio.value = Number(imgElement.getAttribute("width")) / Number(imgElement.getAttribute("height"))
            } else {
                card.material.uniforms.map.value = Assets.dnaAssets[7]
                card.material.uniforms.ratio.value = Assets.dnaAssets[7].width / Assets.dnaAssets[7].height
            }
            cards.push(card);
            card.group.position.y = -(index * SPACE)

            const rotation = SLICE * index ;
            const pos = angleToVector(rotation);
            dummyPosition.x = pos.x
            dummyPosition.z = pos.y

            dummyPosition.multiplyScalar(SCALAR);
            dummyPosition.y = card.group.position.y;

            card.group.rotation.y = -(rotation + Math.PI * 0.5);
            card.group.rotation.z = Math.PI * 0.0225;

            card.group.position.copy(dummyPosition);
        }

        this.group.position.z = -(SCALAR + 0.25)
        this.graftFlashCards();
    }

    graftFlashCards() {
        const { lastIndex } = this
        const mainCard = this.cards[lastIndex]
        for(let index = 0; index < 5; index++) {
            // console.log("index", index)
            const card = new Card({ scene: mainCard.group });
            card.material.uniforms.map.value = Assets.graftAssets[index];
            card.material.uniforms.ratio.value = Assets.graftAssets[index].width / Assets.graftAssets[index].height;
            card.group.position.z = -index * 0.001;
            card.group.scale.x = 0;
            card.group.scale.y = 0;

            this.flashCards.push(card);
        }
    }

    enter() {
        const LARGESSE = 1.5;
        const animation = new gsap.timeline();
        const lerp = {
            ry: -SLICE * LARGESSE,
            rry: 0,
            y: 1,
            y2: 1,
        }
        animation.to(lerp, {
            y: 0,
            duration: 2,
            ease: "linear",
            onUpdate: () => {
                this.rail.position.y = THREE.MathUtils.lerp(-(-SPACE * 4), -(6), lerp.y)
                this.group.rotation.y = THREE.MathUtils.lerp(-(-SLICE * 2), -(SLICE * 2), lerp.y)
            }
        }, 'enter')
        return animation
    
    }
    slide(currentIndex = 4) {
        const animation = new gsap.timeline();
        const increment = 1;
        const lerp = {
            y2: 0,
        }
        animation.to(lerp, {
            y2: 1,
            duration: 1,
            ease: "linear",
            onUpdate: () => {
                this.rail.position.y = THREE.MathUtils.lerp(-(-SPACE * currentIndex), -(-SPACE * (currentIndex + increment)), lerp.y2)
                this.group.rotation.y = THREE.MathUtils.lerp(-(-SLICE * (currentIndex -  1 - increment)), -(-SLICE * (currentIndex - 1)), lerp.y2)
            }
        }, 'slice-1')
        return animation
    }
    enterFlashCards() {
        const { lastIndex } = this
        const nextCard = this.cards[lastIndex + 1]
        const mainCard = this.cards[lastIndex]
        const previousCard = this.cards[lastIndex - 1]
        const animation = new gsap.timeline();
        const lerp = {
            x: 0,
            y: 0,
        }
        animation.to(lerp, {
            x: 1,
            duration: 0.5,
            ease: "power3.out",
            onUpdate: () => {
                mainCard.group.rotation.z = THREE.MathUtils.lerp( Math.PI * 0.0225, 0, lerp.x)
            }
        }, 'flashing-cards')
        animation.to(lerp, {
            y: 1,
            duration: 2,
            ease: "linear",
            onUpdate: () => {
                mainCard.mesh.scale.x = THREE.MathUtils.lerp( 1, this.FRUSTUM_WIDTH, lerp.y)
                mainCard.mesh.scale.y = THREE.MathUtils.lerp( 1, this.FRUSTUM_WIDTH, lerp.y)

                nextCard.mesh.position.y = -lerp.y
                previousCard.mesh.position.y = lerp.y

            }
        }, 'flashing-cards')

        this.flashCards.forEach((card, index) => {
            const lerp = {
                x: 0
            }
            animation.to(lerp, {
                x: 1,
                duration: 2,
                ease: "linear",
                onUpdate: () => {
                    card.group.scale.x = THREE.MathUtils.lerp( 0, this.FRUSTUM_WIDTH, lerp.x)
                    card.group.scale.y = THREE.MathUtils.lerp( 0, this.FRUSTUM_WIDTH, lerp.x)

                }
            }, `flashing-cards+=${index * 0.5 + 0.5}`)
        })

        return animation
    }

    dispose() {
        Object.keys(this.components).forEach(_ => {
            this.components[_].dispose();
            delete this.components[_];
        });
    }
}
